export default __webpack_public_path__ + "static/media/MS-Odontontologia.9b36c906.png";